package search.global

import search.searchFilterStores.ActiveReadOnlyKeywordsStore

class ActiveSearchReadOnlyKeywordsStore: ActiveReadOnlyKeywordsStore()